// Minimal Web Speech API wrapper with global mute toggle.
const KEY = "ll_mute";

export function isMuted() {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}
export function setMuted(v) {
  try { localStorage.setItem(KEY, v ? "1" : "0"); } catch {}
}

let voicesCache = null;
function getVoices() {
  if (voicesCache) return voicesCache;
  const v = window.speechSynthesis?.getVoices?.() || [];
  voicesCache = v;
  return v;
}

if (typeof window !== "undefined" && "speechSynthesis" in window) {
  window.speechSynthesis.onvoiceschanged = () => { voicesCache = null; };
}

export function speak(text, opts = {}) {
  if (!text) return;
  if (isMuted()) return;
  if (typeof window === "undefined" || !("speechSynthesis" in window)) return;
  try {
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(String(text));
    utter.rate = opts.rate ?? 0.92;
    utter.pitch = opts.pitch ?? 1.25;
    utter.volume = opts.volume ?? 1;
    const voices = getVoices();
    const preferred = voices.find(v => /child|kid|female/i.test(v.name)) ||
                      voices.find(v => /en(-|_)?(US|GB)/i.test(v.lang)) ||
                      voices[0];
    if (preferred) utter.voice = preferred;
    window.speechSynthesis.speak(utter);
  } catch {}
}

// Cute short jingle for correct answers (Web Audio API)
export function chime(kind = "correct") {
  if (isMuted()) return;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    const ctx = new AC();
    const notes = kind === "correct" ? [523.25, 659.25, 783.99] : [329.63, 261.63];
    let t = ctx.currentTime;
    notes.forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(f, t);
      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(0.18, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.28);
      o.connect(g).connect(ctx.destination);
      o.start(t);
      o.stop(t + 0.3);
      t += 0.14;
    });
    setTimeout(() => ctx.close(), 900);
  } catch {}
}
